import React, { useEffect, useState } from 'react';
import { Paper, Popper } from '@material-ui/core';
import styles from './Onboarding.module.scss';

/** Non-modal coaching: controls and keyboard interaction stay available. */
const LessonCoach = ({ rootRef, resolveTarget, resolveDropTarget, title, description, progress }) => {
  const [dragging, setDragging] = useState(false);
  useEffect(() => {
    const start = () => setDragging(true);
    const end = () => setDragging(false);
    document.addEventListener('dragstart', start);
    document.addEventListener('dragend', end);
    document.addEventListener('drop', end);
    return () => {
      document.removeEventListener('dragstart', start);
      document.removeEventListener('dragend', end);
      document.removeEventListener('drop', end);
    };
  }, []);
  const [anchor, setAnchor] = useState(null);
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    let current = null;
    let destination = null;
    const update = () => {
      // Add/Move dialogs use portals; do not cover them with coaching from the hidden editor.
      const obscured = Boolean(root.closest('[aria-hidden="true"]'));
      const nextDestination = obscured ? null : resolveDropTarget?.(root);
      if (destination !== nextDestination) {
        if (destination) destination.removeAttribute('data-lesson-drop-target');
        destination = nextDestination;
        if (destination) destination.setAttribute('data-lesson-drop-target', 'true');
      }
      const next = obscured ? null : resolveTarget(root);
      if (next === current) return;
      if (current) current.removeAttribute('data-lesson-target');
      current = next;
      if (current) {
        current.setAttribute('data-lesson-target', 'true');
        current.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      setAnchor(current);
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(root.ownerDocument.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    return () => {
      observer.disconnect();
      if (current) current.removeAttribute('data-lesson-target');
      if (destination) destination.removeAttribute('data-lesson-drop-target');
    };
  }, [rootRef, resolveTarget, resolveDropTarget]);

  if (!anchor || dragging) return null;
  return <Popper open anchorEl={anchor} placement="bottom-start" className={styles.coach}
    modifiers={{ preventOverflow: { boundariesElement: 'viewport', padding: 16 }, flip: { boundariesElement: 'viewport', padding: 16 }, offset: { offset: '0, 12' } }}>
    <Paper className={styles.coachCard} elevation={4} role="note">
      <small>{progress}</small><strong>{title}</strong><p>{description}</p>
    </Paper>
  </Popper>;
};
export default LessonCoach;
